import * as Yup from 'yup';

export const model = {
  newEmail: {
    label: '',
    type: 'text',
    name: 'newEmail',
    withBorder: false,
    placeholder: 'Email',
  },
};

export const validationSchema = () =>
  Yup.object().shape({
    [model.newEmail.name]: Yup.string().required().email(),
  });

export const initialValues = (data: any) => {
  return {
    [model.newEmail.name]: data?.email ?? '',
  };
};
